import { render } from "./HelpButton.vue?vue&type=template&id=7f9633be"
import script from "./HelpButton.vue?vue&type=script&lang=js"
export * from "./HelpButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/layout/Header/HelpButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f9633be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f9633be', __exports__)) {
    api.reload('7f9633be', __exports__)
  }
  
  module.hot.accept("./HelpButton.vue?vue&type=template&id=7f9633be", () => {
    api.rerender('7f9633be', render)
  })

}


export default __exports__